// Tailwind's stylesheet rides the TS entrypoint: in dev it arrives over HMR,
// in production vite_rails extracts it and vite_typescript_tag emits the
// <link> alongside the script — no separate vite_stylesheet_tag needed.
import "./application.css"

import { createInertiaApp } from "@inertiajs/react"

import { resolvePage } from "../pages"

// The Inertia client bootstrap. `resolve` is the classic Inertia resolver
// callback — the domain-qualified page identifier a controller renders
// (e.g. "schedule/Days") is handed straight to app/shared/pages.ts. `setup`
// is intentionally omitted: @inertiajs/react's default mounts with
// `createRoot`, which is all this application needs.
void createInertiaApp({
  resolve: resolvePage,
})
